import { render, staticRenderFns } from "./patentDemandRow.vue?vue&type=template&id=79314276&scoped=true&"
import script from "./patentDemandRow.vue?vue&type=script&lang=js&"
export * from "./patentDemandRow.vue?vue&type=script&lang=js&"
import style0 from "./patentDemandRow.vue?vue&type=style&index=0&id=79314276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79314276",
  null
  
)

export default component.exports